"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = require("./updateFavoritesUserOption");
var addRemoveFavoriteService_1 = require("../services/addRemoveFavoriteService");
var store_1 = require("../store/store");
var Store_1 = require("owa-mail-store/lib/store/Store");
var legacy_1 = require("satcheljs/lib/legacy");
var datapoints_1 = require("../datapoints");
/**
 * Add a favorite node to the favorite store
 * @param idToUpdate the id to update
 * @param state the state which contains the favoritesFolderNodes and the folder to update
 */
exports.default = legacy_1.action('AddFavoriteFolder', datapoints_1.default.AddFavoriteFolder)(legacy_1.select({
    favoritesFolderNodes: function () { return store_1.default.favoritesFolderNodes; },
    orderedFavoritesNodeIds: function () { return store_1.default.orderedFavoritesNodeIds; },
    folder: function (idToUpdate, isAdd) { return Store_1.default.folders.folderTable.get(idToUpdate); },
})(function addFavoriteFolder(idToUpdate, actionSource, state) {
    // Check if favoritesFolderNodes already has the same folder id
    if (state.favoritesFolderNodes.has(idToUpdate)) {
        throw new Error('Cannot add duplicate folder to favorites.');
    }
    // Add to favorite to favorites store
    state.orderedFavoritesNodeIds.push(idToUpdate);
    state.favoritesFolderNodes.set(idToUpdate, {
        id: idToUpdate,
        type: 0 /* Folder */,
    });
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
    // Service request for FAI that used by outlook desktop
    addRemoveFavoriteService_1.default(state.folder, true /* isAdd */);
}));
//# sourceMappingURL=addFavoriteFolder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/addFavoriteFolder.js
// module id = 3330
// module chunks = 14 68